'use client'

import { useEffect } from 'react'
import { shouldClearCache } from '@/utils/pwaCacheManager'

/**
 * PWA 緩存檢查組件
 * 
 * ⚠️ 重要變更：此組件不再自動清除緩存
 * 改為「阻擋使用，保留資料」的策略：
 * - 只檢查緩存狀態（用於記錄或顯示提示）
 * - 不執行任何清除動作
 * - 學習記錄永遠保留
 * 
 * 權限檢查會在 middleware 和 API routes 中處理
 */
export default function PWACacheChecker() {
  useEffect(() => {
    // 只在客戶端執行
    if (typeof window === 'undefined') return
    
    // 只在 PWA 模式下執行（已安裝）
    const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                  (window.navigator as any).standalone === true
    
    if (!isPWA) {
      return
    }

    const checkStatus = () => {
      // ⚠️ 變更：只檢查狀態，不執行清除
      const { reason } = shouldClearCache()
      
      // 可選：記錄狀態（用於除錯或顯示提示）
      if (reason === 'subscription_expired') {
        // 訂閱已過期，但不清除緩存
        // 權限檢查會在 middleware 和 API routes 中處理
        if (process.env.NODE_ENV === 'development') {
          console.log('[PWA Cache] 訂閱已過期（緩存保留，僅阻擋使用）')
        }
      } else if (reason === 'cache_expired') {
        // 緩存清除日已到期，但不清除緩存
        if (process.env.NODE_ENV === 'development') {
          console.log('[PWA Cache] 緩存清除日已到期（緩存保留）')
        }
      }
    }

    // 延遲檢查，避免影響頁面載入
    setTimeout(() => {
      checkStatus()
    }, 1000)
  }, [])

  // 這個組件不渲染任何內容
  return null
}

